import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=19ea953e"
import script from "./FolderTree.vue?vue&type=script&lang=js"
export * from "./FolderTree.vue?vue&type=script&lang=js"
import style0 from "./FolderTree.vue?vue&type=style&index=0&id=19ea953e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports